export default "__VITE_ASSET__ClFwMRfP__"